import {Component, OnInit, ViewChild} from "@angular/core";
import {DossierService} from "../../../../../../services";
import {DictionaryService} from "@amlCore/services";
import {AlertPanelService, ITable, ITableCallBack, ITableItemDescriptor, TableCompComponent} from "@amlCore/components";
import {DossierBaseModel} from "../../../dossierBaseModel";
import {FormBuilder} from "@angular/forms";
import {ErrorFLKModel} from "@amlCore/models";
import {SostavIOInfoDossierComponent} from "./sostavIOInfoDossier.component";
import {DossierBaseSubComponent} from "../../dossierBaseSub.component";
import {SostavIOType} from "../../../../../../models";

@Component({
  selector: 'app-sostavio-dossier',
  styleUrls: ['../../../dossier.css'],
  templateUrl: './sostavIODossier.component.html'
})
export class SostavIODossierComponent extends DossierBaseSubComponent implements OnInit, ITable {

  @ViewChild('tableComp') tableComp: TableCompComponent;
  itemDescriptor: ITableItemDescriptor;

  constructor(protected dossierService: DossierService, protected dictSrv: DictionaryService,
              private dossierBaseModel: DossierBaseModel, protected formBuilder: FormBuilder,
              protected alertPanelService: AlertPanelService) {
    super(dossierService, dictSrv, alertPanelService);
  }

  ngOnInit() {
    // Описание элемента таблицы
    this.itemDescriptor = {
      create: this.dossierBaseModel.getSostavIOInfo.bind(this.dossierBaseModel),
      component: SostavIOInfoDossierComponent,
      params: {
        typePage: this.typePage
      }
    } as ITableItemDescriptor;
  }

  callbackItemOpened(event: ITableCallBack){
    if(event?.editIndex != null && this.errorFLKData && this.errorFLKData[event.editIndex]) {
      this.tableComp.initErrorFLK(this.errorFLKData[event.editIndex]);
    }
  }

  callbackItemClosed(event: ITableCallBack) {
    if (event.editIndex !== null && event.editIndex !== -1) {
      // При закрытие элемента думаем, что ошибки поправлены
      const row = (this.formGroupApp.value[event.editIndex] as SostavIOType).row;
      this.setValidFlkError(row);
    }
  }

  openWindow(error: ErrorFLKModel){
    let index = 0;
    // Считываем row и ищем по нему index
    if (error && error.row !== null) {
      (this.formGroupApp.value as Array<SostavIOType>).forEach((value, i) => {
        if (value.row === error.row) {
          index = i;
        }
      });
    }
    this.tableComp.showFlKError(index, error);
  }

}
